import {stripeConnectApi} from "@/container";
import {OrganizationStripeAccount, StripeConnectOnboardingOutcome} from "@/stripe-connect/interfaces";

const StripeConnectService = () => {
    return {
        /**
         * Get the connected account state, null when not created yet.
         */
        async getAccount(): Promise<OrganizationStripeAccount | null> {
            return stripeConnectApi().getAccount();
        },

        /**
         * Start the online payments activation: create the connected account
         * if needed, then open the stripe hosted onboarding window.
         */
        async startOnboarding(): Promise<void> {
            await stripeConnectApi().createAccount();

            return this.openOnboardingWindow();
        },

        /**
         * Open a fresh onboarding window for an existing account. Account Links
         * are single use: a new link is generated on every call.
         */
        async openOnboardingWindow(): Promise<void> {
            const link = await stripeConnectApi().createOnboardingLink();

            window.ipcRenderer.stripeConnectOnboarding(link.url);
        },

        /**
         * Listen to the onboarding window closing. The callback receives the
         * navigation outcome; the account state must be re-fetched regardless.
         */
        onOnboardingWindowClosed(callback: (outcome: StripeConnectOnboardingOutcome) => void): void {
            window.ipcRenderer.onStripeConnectOnboardingClosed(callback);
        },

        /**
         * Remove the onboarding window closing listeners.
         */
        removeOnboardingWindowClosedListeners(): void {
            window.ipcRenderer.removeStripeConnectOnboardingClosedListeners();
        }
    };
};

export default StripeConnectService();
